var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container",style:({height:_vm.card_height+'px'})},[_c('img',{staticClass:"picture",attrs:{"src":_vm.img}}),_c('div',{staticClass:"padding"},[_c('div',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }